export default "__VITE_ASSET__95b19c9f__"